import type { MostValuableCompanyResponse, Power20CompanyResponse } from '@/types/company';
import type { FilterItems } from '@/types/filter';

export const getMostValuableCompanies = async (
  keyword: string,
  pageNum: number,
  pageSize: number,
  sortField: string,
  direction: string,
  filterItems: FilterItems
): Promise<MostValuableCompanyResponse> => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_APP_API_BASE_URL}/polaris-api/market/company-list?keyword=${keyword ? encodeURIComponent(keyword) : ''}&pageNum=${pageNum || ''}&pageSize=${pageSize || ''}&sortField=${sortField || ''}&direction=${direction || ''}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(filterItems)
      }
    );

    return await response.json();
  } catch (error) {
    console.error('Error fetching companies:', error);
    throw error;
  }
}

export const getPower20Companies = async (): Promise<Power20CompanyResponse> => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_APP_API_BASE_URL}/polaris-api/market/power-20-company-list`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return await response.json();
  } catch (error) {
    console.error('Error fetching power 20 companies:', error);
    throw error;
  }
}
